import { defineStore } from "pinia";

export const useSpeedTestStore = defineStore("speedtest", () => {
  let ping = [];
  let jitter = [];
  let downloadTestOver = false;
  let downloadTestStarted = false;
  let totalDownloadedPerReq = [];
  let totalDownloaded = 0;
  let reqs = [];

  async function headPing(url, i, count, grace) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const req = new XMLHttpRequest();
        req.addEventListener("readystatechange", async (_ev) => {
          if (req.readyState == 1) performance.mark("Start");
          else if (req.readyState == 2) {
            performance.mark("Header");
            let delta = performance.measure("delta", "Start", "Header");
            if (ping.length > 0) {
              jitter.push(Math.abs(ping[ping.length - 1] - delta.duration));
            }
            if (i >= grace) {
              ping.push(delta.duration);
            }
          } else if (req.readyState == 4) {
            performance.clearMarks();
            performance.clearMeasures();
            if (i + 1 < count + grace) {
              const res = await headPing(url, i + 1, count, grace);
              resolve(res);
            } else {
              if (ping.length == 0) {
                resolve({
                  networkPing: {
                    value: -1,
                    label: "Ping/ms",
                  },
                });
              } else {
                const weightedPing =
                  ping.reduce((acc, val) => acc + val) / ping.length;
                resolve({
                  networkPing: {
                    value: weightedPing,
                    label: "Ping/ms",
                  },
                });
              }
            }
          }
        });
        req.addEventListener("error", (error) => {
          console.log("Ping test failed: ", error);
          throw new Error("Ping test failed");
        });
        req.addEventListener("abort", (error) => {
          console.log("Ping test failed: ", error);
          throw new Error("Ping test failed");
        });
        req.addEventListener("timeout", (error) => {
          console.log("Ping test failed: ", error);
          throw new Error("Ping test failed");
        });
        req.open("HEAD", url + "?r=" + Math.random(), true);
        req.send();
      }, 250);
    });
  }

  async function pingTest(url, count, grace = 2) {
    try {
      const res = await headPing(url, 0, count, grace);
      return res;
    } catch (e) {
      console.log("Could not complete ping test:", e);
      return {
        networkPing: {
          value: -1,
          label: "Ping/ms",
        },
      };
    }
  }

  function setupDownloadXHR(i, url, duration) {
    if (downloadTestOver) return;
    reqs[i] = new XMLHttpRequest();
    totalDownloadedPerReq[i] = 0;
    reqs[i].addEventListener("readystatechange", (_ev) => {
      if (reqs[i].readyState == 3 && !downloadTestStarted) {
        downloadTestStarted = true;
        setTimeout(() => {
          downloadTestOver = true;
          downloadTestStarted = false;
        }, duration);
      }
    });
    reqs[i].addEventListener("progress", (progressEvent) => {
      if (progressEvent.loaded > totalDownloadedPerReq[i])
        totalDownloadedPerReq[i] = progressEvent.loaded;
      if (downloadTestOver) {
        reqs[i].abort();
      }
    });
    reqs[i].addEventListener("load", (event) => {
      if (!downloadTestOver) {
        totalDownloaded += event.total;
        setupDownloadXHR(i, url, duration);
      }
    });
    reqs[i].addEventListener("error", (error) => {
      console.log("Download test failed: ", i, error);
      setupDownloadXHR(i, url, duration);
    });
    reqs[i].open("GET", url + "?r=" + Math.random(), true);
    if (!downloadTestOver) {
      reqs[i].send();
    }
  }

  async function bandwidthTest(url, duration, parallelCount = 6) {
    return new Promise((resolve) => {
      ping = [];
      jitter = [];
      downloadTestOver = false;
      downloadTestStarted = false;
      totalDownloadedPerReq = [];
      totalDownloaded = 0;
      reqs = [];
      for (let i = 0; i < parallelCount; i++) {
        setupDownloadXHR(i, url, duration * 1000);
      }
      setTimeout(() => {
        resolve({
          networkBandwidth: {
            value: Math.round(
              (
                ((totalDownloaded +
                  totalDownloadedPerReq.reduce((acc, val) => {
                    return acc + val;
                  })) *
                  8) /
                duration /
                1024 /
                1024
              ).toFixed(2)
            ),
            label: "Bandwidth/Mbps",
          },
        });
      }, duration * 1000);
    });
  }

  return {
    pingTest,
    bandwidthTest,
  };
});
